import { IApp03EpicDep } from '../types';
import { EntityService } from './EntityService';

export class App03EpicDepService extends EntityService<IApp03EpicDep> {
    constructor() {
        super(`/App03EpicDeps`);
    }

}